module.exports = __webpack_public_path__ + "img/padlock.d2a6adc6.svg";